/**
 * Print Wealth chapter — Canva page-08 template plus "This month's pulse".
 * Own A4 sheet. Uses hero-wealth.jpg (user high-res wooden cubes).
 */

import React from "react";
import type { MonthlyConsultationBundle } from "../../../../utils/forecast/monthlyConsultation";
import { PdfAspectDeepDive } from "./PdfAspectDeepDive";

/**
 * Props for the PDF wealth chapter.
 */
export interface PdfChapterWealthProps {
  /** Full monthly consultation payload. */
  bundle: MonthlyConsultationBundle;
  /** 1-based sequential page index among rendered sheets. */
  pageNumber?: number;
}

/**
 * Resolve Wealth scorecard row from the bundle.
 *
 * @param bundle - Monthly consultation payload
 * @returns Matching scorecard dimension or null
 */
function wealthScore(bundle: MonthlyConsultationBundle) {
  const rows = Array.isArray(bundle.scorecard) ? bundle.scorecard : [];
  const match = rows.find((row) => {
    const label = typeof row.label === "string" ? row.label.trim().toLowerCase() : "";
    return label === "wealth" || label.includes("wealth") || label.includes("money");
  });
  return match ?? null;
}

/**
 * Wealth life-area deep dive — always starts on its own page.
 */
export const PdfChapterWealth: React.FC<PdfChapterWealthProps> = ({
  bundle,
  pageNumber,
}) => (
  <PdfAspectDeepDive
    chapterId="wealth"
    title="Wealth"
    eyebrow="Life areas"
    playbook={bundle.aspectPlaybooks.wealth}
    snapshot={bundle.aspectPalaces.wealth}
    scorecard={wealthScore(bundle)}
    breakBefore="always"
    pageNumber={pageNumber}
  />
);

export default PdfChapterWealth;
